import React from "react";
import { Helmet } from "react-helmet-async";
import TawkChat from "../common/TawkChat";

const Meta = ({ title, description, keywords }) => {
  const defaultTitle =
    "BeyondLeadz | Marketing & Sales Automation Suite for Hotels";
  const defaultDescription =
    "BeyondLeadz offers a comprehensive marketing and sales automation suite designed to optimize hotel operations, improve guest engagement, and drive revenue through advanced data analytics.";
  const defaultKeywords =
    "hotel marketing automation, sales CRM, hotel data management, lead generation, hotel sales software, guest engagement, hotel revenue optimization, hospitality CRM, marketing automation, B2B sales";

  return (
    <>
      <Helmet>
        <title>{title || defaultTitle}</title>
        <meta name="description" content={description || defaultDescription} />
        <meta name="keywords" content={keywords || defaultKeywords} />
        {/* og tags */}
        <meta property="og:title" content={title || defaultTitle} />
        <meta property="og:description" content={description || defaultDescription} />
        <meta property="og:type" content="website" />
      </Helmet>
      <TawkChat />
    </>
  );
};

export default Meta;
